import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { components, DropdownIndicatorProps } from "react-select";
import styled from "styled-components";
import { useSelector } from "redux/hooks";
import { AccountArrowIcon, CompatibleModIcon, SelectedLanguageCross } from "components/Header/Icons/AccountArrowIcon";

// import { AccountArrowIcon } from "components/Header/Icons/AccountArrowIcon";


const Arrow = styled(FontAwesomeIcon)`
  margin-top: -6px;
`;
interface CustomDropdownIndicatorProps extends DropdownIndicatorProps {
  account?: boolean; 
  signup?:boolean;
  compatibleMod?: boolean;
  filtergptModelLanguage?: boolean;
  value?: string;
  onClearValue?: () => void; // Use a different name to avoid conflict
}
export const DropdownIndicator = ({
  account,
  signup,
  compatibleMod,
  filtergptModelLanguage,
  value,
  onClearValue,
  ...props
}: CustomDropdownIndicatorProps) => {
  const { theme } = useSelector((state) => state.authReducer);
  // Handle click on the cross icon
  const handleClearClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    
    if (onClearValue) {
      onClearValue();
    }
  };

  return (
    <components.DropdownIndicator {...props}>
      {/* <Arrow icon={faSortDown} /> */}
      {value && filtergptModelLanguage? 
      <div className="mt-[3px] cursor-pointer" onClick={handleClearClick}
          onMouseDown={handleClearClick} >
        <SelectedLanguageCross />
      </div> : (filtergptModelLanguage || compatibleMod)? <CompatibleModIcon filtergptModelLanguage={true} /> : account || signup ? <AccountArrowIcon theme={theme} signup={true}/> : <Arrow icon={faSortDown} />}
    </components.DropdownIndicator>
  );
};